var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Doc_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doc_icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper1-3",
    transform: "translate(10.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4840017,0.127337734 C24.8923366,0.127337734 5.15375184,0.94134425 5.15375184,0.94134425 C2.94512606,1.02811105 1.1546811,2.89585451 1.1546811,5.10604535 L1.1546811,66.9631153 C1.1546811,69.1764494 2.94114836,70.9707112 5.16242555,70.9707112 L60.829349,70.9707112 C63.0427651,70.9707112 64.8370934,69.1733061 64.8370934,66.9631153 L64.8370934,5.10604535 C64.8370934,2.89271124 63.0485164,1.02062086 60.8333269,0.927069569 C60.8333269,0.927069569 43.0835905,0.127337734 34.4840017,0.127337734 Z",
    id: "Rectangle-18",
    stroke: "#AFC0D3",
    fill: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2851303,1.58691268 C23.452224,1.58691268 3.11637012,2.40924223 3.11637012,2.40924223 C0.907876931,2.49440136 0.89220497,2.72725881 3.10627278,2.9316431 L56.643191,7.87372542 C58.8461076,8.07708033 60.7366825,10.0366615 60.8648919,12.2331603 L64.1686692,68.8338744 C64.2973336,71.0381688 64.4016367,71.0354544 64.4016367,68.8207301 L64.4016367,6.56780896 C64.4016367,4.3562551 62.6069824,2.48681029 60.4064163,2.39556605 C60.4064163,2.39556605 42.1010085,1.58691268 33.2851303,1.58691268 Z",
    id: "Rectangle-19",
    fill: "#FFFFFF",
    opacity: 0.626340951,
    transform: "translate(32.376359, 36.165226) scale(1, -1) translate(-32.376359, -36.165226) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-28",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 9.01703633,
    y: 11.7578489,
    width: 15.8666466,
    height: 4.52331542,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-29",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 9.01703633,
    y: 20.1915839,
    width: 39.4781272,
    height: 4.52331542,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-30",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 9.01703633,
    y: 28.6253188,
    width: 47.0675312,
    height: 4.52331542,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-30",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 9.01703633,
    y: 37.0590537,
    width: 47.0675312,
    height: 4.52331542,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-31",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 9.01703633,
    y: 45.4927887,
    width: 47.0675312,
    height: 4.52331542,
    rx: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.563140450fe26ecbc183ce914892c02c.svg";
export { ForwardRef as ReactComponent };